import type { ReactNode } from 'react';
import { useState } from 'react';

import { MessagingContext, MessagingProvider } from '@sorare/wallet-shared';

import { WALLET_URL } from '#src/config.ts';

import { Wallet } from './Wallet/index.tsx';
import { WalletLoadedProvider } from './walletLoaded/index.tsx';

interface Props {
  children: ReactNode;
}

export const WalletProvider = ({ children }: Props) => {
  const [window, setWindow] = useState<Window | undefined>(undefined);

  return (
    <MessagingProvider
      Context={MessagingContext}
      allowedOrigins={[WALLET_URL]}
      target={{ window, origin: WALLET_URL }}
    >
      <WalletLoadedProvider>
        <Wallet setWindow={setWindow}>{children}</Wallet>
      </WalletLoadedProvider>
    </MessagingProvider>
  );
};
